/**
 * Custom vehicle icons. lucide-react still has no `Motorcycle` or `Scooter`
 * primitive, so we draw both as outlined SVGs that match the lucide stroke
 * conventions (1.8 stroke, round caps, currentColor).
 *
 * Both icons accept the standard `className` / `strokeWidth` props so they
 * slot into existing icon tiles without extra styling.
 */

export const MotorcycleIcon = ({ className = "", strokeWidth = 1.8 }) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        {/* Front + rear wheels */}
        <circle cx="5" cy="17.5" r="2.8" />
        <circle cx="19" cy="17.5" r="2.8" />
        {/* Handlebar */}
        <path d="M8 6 L 11.5 6" />
        {/* Front fork from handlebar down to the front wheel hub */}
        <path d="M9.5 6 L 5 17.5" />
        {/* Tank top */}
        <path d="M9 10 L 14 10" />
        {/* Seat slope going down toward the rear */}
        <path d="M14 10 L 17.5 12.5" />
        {/* Rear strut from seat to rear wheel */}
        <path d="M17 12 L 19 17.5" />
        {/* Lower frame connecting front fork to rear wheel center */}
        <path d="M7 14 L 15 14 L 19 17.5" />
    </svg>
);

export const ScooterIcon = ({ className = "", strokeWidth = 1.8 }) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        {/* Front + rear wheels */}
        <circle cx="5.5" cy="18" r="2.5" />
        <circle cx="18.5" cy="18" r="2.5" />
        {/* Leg shield rising from front wheel up to the handlebar */}
        <path d="M5.5 15.5 L 6.5 8" />
        {/* Handlebar */}
        <path d="M6 8 L 10.5 8" />
        {/* Vespa-style body: seat / rear shell curving over the rear wheel */}
        <path d="M8 11 L 14.5 11 Q 18 11.5 18.5 15.5" />
        {/* Step-through floorboard between the wheels */}
        <path d="M8 17 L 16 17" />
    </svg>
);
